
import { Record } from 'immutable'
const CreateUserForm = Record({
  mail:null,
});
export default CreateUserForm;
